import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import AddTransferTemplatePage, { getDefaultData, getDefaultUI } from "components/pages/AddTransferTemplatePage";
import Classes from "model";

/**
 * @name CaptureAddTemplateMainFromDDOpen
 * @returns {React.Component}
 * @description 
 * This capture is used in the following capture groups:
 * "Transfer Templates" (abi22).
 */
export default function CaptureAddTemplateMainFromDDOpen(props) {
    // Initialize all the model classes
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);

    // Initalize a new BCMSStateManagerCRUD instance using the default page data
    // Then updating the from, to and amount properties of the transfer
    const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update([ "template", "name" ], "Sample")
    .submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultUI())
    .update([ "from", "isActive" ], true)
    .submit();

    // Return the TransfersPage passing the data and ui variables
    return <AddTransferTemplatePage data={ data } ui={ ui } />
}